import { createFileRoute, Link, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { HelpSectionForm } from '@/admin/sitecontent/HelpSectionForm';
import { DetailPage } from '@/admin/ui/Editor';
import { BackLink } from '@/admin/ui/NavLinks';
import { PageTitle } from '@/admin/ui/Page';

export const Route = createFileRoute('/admin/help/sections/new')({
  staticData: { minTier: 'ADMIN' },
  component: NewHelpSection,
});

function NewHelpSection() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <DetailPage>
      <BackLink>
        <Link to="/admin/help/sections/">{t('admin.help.backToSections')}</Link>
      </BackLink>
      <PageTitle>{t('admin.help.newSection')}</PageTitle>
      <HelpSectionForm
        onSaved={(id) =>
          navigate({
            to: '/admin/help/sections/$sectionId/',
            params: { sectionId: String(id) },
          })
        }
        onCancel={() => navigate({ to: '/admin/help/sections/' })}
      />
    </DetailPage>
  );
}
